'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dPage$0024 from "./presto.-Dashboard-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499 from "./presto.-Presto-Router$$anon$99.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$98() {
  this.bqh = null;
  this.bq9 = null;
  this.bqa = false;
  this.bqi = null;
  this.bqj = false;
  this.bqm = null;
  this.bqf = null;
  this.bqg = false;
  this.bqb = null;
  this.bqc = false;
  this.bqd = null;
  this.bqe = false;
  this.bqk = false;
  this.bql = false;
  this.bqh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bqm = "DashboardPage";
}
export { $c_Lpresto_PrestoRouter$$anon$98 as $c_Lpresto_PrestoRouter$$anon$98 };
$p = $c_Lpresto_PrestoRouter$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$98;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$98() {
}
export { $h_Lpresto_PrestoRouter$$anon$98 as $h_Lpresto_PrestoRouter$$anon$98 };
$h_Lpresto_PrestoRouter$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bqh;
});
$p.L = (function() {
  if ((!this.bqa)) {
    this.bq9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bqa = true;
  }
  return this.bq9;
});
$p.O = (function() {
  if ((!this.bqj)) {
    this.bqi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bqj = true;
  }
  return this.bqi;
});
$p.E = (function() {
  return this.bqm;
});
$p.t = (function() {
  if ((!this.bqg)) {
    this.bqf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqg = true;
  }
  return this.bqf;
});
$p.M = (function() {
  if ((!this.bqc)) {
    this.bqb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqc = true;
  }
  return this.bqb;
});
$p.Q = (function() {
  if ((!this.bqe)) {
    this.bqd = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499.$c_Lpresto_PrestoRouter$$anon$99();
    this.bqe = true;
  }
  return this.bqd;
});
$p.w = (function() {
  if ((!this.bql)) {
    this.bqk = false;
    this.bql = true;
  }
  return this.bqk;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee604) => ((p) => \u03b4scrutinee604))($j_presto$002e$002dDashboard$002dPage$0024.$m_Lpresto_DashboardPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$98, "presto.PrestoRouter$$anon$98", ({
  P8: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$98 as $d_Lpresto_PrestoRouter$$anon$98 };
//# sourceMappingURL=presto.-Presto-Router$$anon$98.js.map
